//The contents of this file have been generated automatically. Do not edit this file.

import { z } from 'zod';
import {
    TradingSearchPagedResponseSportZod,
    TradingSearchErrorResponseZod,
} from './schemas';

export const ParamsTypeZOD = z.object({
    page: z.number().optional(),
    pageSize: z.number().optional(),
});
export type ParamsType = z.TypeOf<typeof ParamsTypeZOD>;

const checkResponse = <A>(code: number, decoder: z.ZodType<A>, data: unknown): A => {
    const decodeResult = decoder.safeParse(data);
    if (decodeResult.success) {
        return decodeResult.data;
    }
    console.error('error details', {
        errors: decodeResult.error.errors,
        data
    });
    throw Error(`Response decoding error /trading-search/v1/sports -> get -> ${code}`);
};


export const Response200ZOD = TradingSearchPagedResponseSportZod;
export type Response200Type = z.TypeOf<typeof Response200ZOD>;

export const Response400ZOD = TradingSearchErrorResponseZod;
export type Response400Type = z.TypeOf<typeof Response400ZOD>;

export const Response404ZOD = z.unknown();
export type Response404Type = z.TypeOf<typeof Response404ZOD>;

export const Response500ZOD = TradingSearchErrorResponseZod;
export type Response500Type = z.TypeOf<typeof Response500ZOD>;


const ExtraHeadersZod = z.object({
    authorization: z.string().optional(),
});
type ExtraHeadersType = z.TypeOf<typeof ExtraHeadersZod>;


export type ApiGetSportsParamsType = ParamsType;


export type ApiGetSportsResponseType = 
    {
        status: 200;
        body: Response200Type;
    } | 
    {
        status: 400;
        body: Response400Type;
    } | 
    {
        status: 404;
        body: Response404Type;
    } | 
    {
        status: 500;
        body: Response500Type;
    };

export type ApiGetSportsResponse200Type = Response200Type;

const convertHeaders = (params: Record<string, string | null | undefined>): Record<string, string> => {
    const result: Record<string, string> = {};

    for (const [name, value] of Object.entries(params)) {
        if (value !== null && value !== undefined) {
            result[name] = value;
        }
    }

    return result;
};

export const apiGetSportsRequest = async (
    api_url: string,
    params: ParamsType,
    extraHeaders: ExtraHeadersType
): Promise<ApiGetSportsResponseType> => {
    const ok = ParamsTypeZOD.safeParse(params);
    if (!ok.success) {
        console.error('Input parameters do not match the definition from openapi');
    }

    
        
    const query = ((): string => {
        const query: string[] = [];

        const addParam = (param: string, value: string | string[] | number | boolean | null | undefined): void => {
            if (typeof value === 'string') {
                query.push(`${param}=${encodeURIComponent(value)}`);
                return;
            }

            if (typeof value === 'number' || typeof value === 'boolean') {
                query.push(`${param}=${value.toString()}`);
                return;
            }

            if (Array.isArray(value)) {
                for (const v of value) {
                    query.push(`${param}=${encodeURIComponent(v)}`);
                }
                
                return;
            }
        };

        
        addParam('page', params.page);
        addParam('pageSize', params.pageSize);

        return query.length > 0 ? `?${query.join('&')}` : '';
    })();
    const url = `${api_url}/trading-search/v1/sports${query}`;
    

    const headers = convertHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        ...extraHeaders
    });

    const response = await fetch(url, {
        method: 'GET',
        headers,
        body: JSON.stringify(undefined),
        credentials: 'include'
    });

    const status = response.status;

    let json = null;

    try {
        const text = await response.text();
        if (text !== '') {
            json = JSON.parse(text);
        }
    } catch (_err) {
        throw Error(`Http status ${status} - json was expected`);
    }
    
    if (status === 200) {
        return { status: 200, body: checkResponse(200, Response200ZOD, json) };
    }

    if (status === 400) {
        return { status: 400, body: checkResponse(400, Response400ZOD, json) };
    }

    if (status === 404) {
        return { status: 404, body: checkResponse(404, Response404ZOD, json) };
    }

    if (status === 500) {
        return { status: 500, body: checkResponse(500, Response500ZOD, json) };
    }

    throw new Error(`apiGetSportsRequest - unhandled response ${status}`);
};
